export const ZENDESK_HELP_CENTER_BASE_URL = 'https://support.fishbrain.com';
export const ZENDESK_HELP_CENTER_LOCALE = 'en-us';
export const ZENDESK_HELP_CENTER_URL = `${ZENDESK_HELP_CENTER_BASE_URL}/hc/${ZENDESK_HELP_CENTER_LOCALE}`;

export const getZendeskArticleUrl = (article: string): string =>
  `${ZENDESK_HELP_CENTER_URL}/articles/${article}`;

export const ZENDESK_MIN_PER_PAGE = 1;
export const ZENDESK_MAX_PER_PAGE = 10;
export const ZENDESK_DEFAULT_PER_PAGE = 5;

export const FEATURE_FAQ_LABELS = {
  biteguide: 'BiteGuide',
} as const;
